import {
  SAVE_COMPANY_CHANNELS,
  SAVE_COMPANY_EMPLOYEES,
  SAVE_PAYMENT_PLANS,
  START_FETCHING_CHANNELS,
  STOP_FETCHING_CHANNELS,
} from '../actions';
import Immutable from 'immutable';

const defaultState = Immutable.Map({
  isFetchingChannels: false,
  plans: [],
  channels: [],
  employees: [],
});

export function companies(state = defaultState, action = null) {
  switch (action.type) {
    case SAVE_PAYMENT_PLANS: {
      return state.set('plans', action.plans);
    }
    case SAVE_COMPANY_CHANNELS: {
      return state.set('channels', action.channels);
    }
    case SAVE_COMPANY_EMPLOYEES: {
      return state.set('employees', action.employees);
    }
    case START_FETCHING_CHANNELS: {
      return state.set('isFetchingChannels', true);
    }
    case STOP_FETCHING_CHANNELS: {
      return state.set('isFetchingChannels', false);
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/companies.js